import { IPromise } from 'angular';
import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { ArchitecturalRequestApprovalCreateDTO } from '@manager-base/data/dtos/associations/architectural-request-approval-create.dto';
import { ArchitecturalRequestApprovalDTO } from '@manager-base/data/dtos/associations/architectural-request-approval.dto';

const actions = {
    getArchitecturalRequestApprovals: {
        method: 'GET',
        url: `${BASE_PATH_API}/v1/associations/:associationId/architecturalRequests/:architecturalRequestId/approvals`,
    },

    createArchitecturalRequestApprovals: {
        method: 'POST',
        url: `${BASE_PATH_API}/v1/associations/:associationId/architecturalRequests/:architecturalRequestId/approvals`,
    },

    deleteArchitecturalRequestApprovalStatus: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/v1/associations/:associationId/architecturalRequests/:architecturalRequestId/approvals/:approverId`
    },

    sendArchitecturalRequestApprovalRequestNotification: {
        method: 'POST',
        url: `${BASE_PATH_API}/v1/associations/:associationId/architecturalRequests/:architecturalRequestId/approvals/:approverId/sendReminder`
    }

};

export interface IArchitecturalRequestApprovalsApi {
    getArchitecturalRequestApprovals(params: { associationId: number, architecturalRequestId: number }): IPromise<ArchitecturalRequestApprovalDTO>;
    createArchitecturalRequestApprovals(params: { associationId: number, architecturalRequestId: number }, dto: ArchitecturalRequestApprovalCreateDTO): IPromise<any>;
    deleteArchitecturalRequestApprovalStatus(params: { associationId: number, architecturalRequestId: number, approverId: number }): IPromise<any>;
    sendArchitecturalRequestApprovalRequestNotification(params: { associationId: number, architecturalRequestId: number, approverId: number }): IPromise<any>;
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function ArchitecturalRequestApprovalsApi(): IArchitecturalRequestApprovalsApi {
    return createActions(actions);
}
